<template>
  <select ref="select" class="form-control m-select2 gl-type-select" style="width: 100%" :disabled="disabled"></select>
</template>

<script>
/**
 * ISS-45 (8 ต.ค. 2026) ช่อง "หมวดหมู่" ของการ์ด GL — select2 แบบ tags
 * แทน <datalist> ของ ISS-39 ซึ่ง Chrome กรองตัวเลือกด้วยค่าที่อยู่ในช่องเสมอ
 * (คลิกแล้วเห็นแค่ค่าที่เลือกอยู่) และวาด popup เป็นกล่องสีดำตามธีมเบราว์เซอร์
 * คงเงื่อนไขของ BA (QA BUG-12): เลือกจากหมวดหมู่ที่มีใน DB + พิมพ์ชื่อใหม่ได้
 */
export default {
  props: {
    value: String,
    options: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "เลือกหรือพิมพ์หมวดหมู่",
    },
  },
  mounted: function () {
    this.init();
  },
  watch: {
    options: function () {
      this.destroy();
      this.init();
    },
    value: function (value) {
      var $select = $(this.$refs.select);
      if (($select.val() || "") === (value || "")) return;
      this.ensureOption(value);
      $select.val(value || null).trigger("change.select2");
    },
    disabled: function (disabled) {
      $(this.$refs.select).prop("disabled", disabled);
    },
  },
  methods: {
    init: function () {
      var self = this;
      var $select = $(self.$refs.select);

      // option ว่างตัวแรก — select2 ต้องมีถึงจะแสดง placeholder และล้างค่าได้
      $select.empty().append(new Option("", "", false, false));
      (self.options || []).forEach(function (name) {
        $select.append(new Option(name, name, false, false));
      });
      // ค่าที่บันทึกไว้แต่ไม่อยู่ในรายการ (เช่น หมวดหมู่ที่เพิ่งพิมพ์ใหม่) ต้องยังแสดงได้
      self.ensureOption(self.value);

      $select
        .select2({
          tags: true,
          width: "100%",
          placeholder: self.placeholder,
          allowClear: true,
          maximumInputLength: 200,
          createTag: function (params) {
            var term = $.trim(params.term);
            return term ? { id: term, text: term, newTag: true } : null;
          },
        })
        .val(self.value || null)
        .trigger("change.select2")
        .on("change", function () {
          var selected = $select.val() || "";
          if (selected !== (self.value || "")) self.$emit("input", selected);
        });
    },
    ensureOption: function (value) {
      if (!value) return;
      var $select = $(this.$refs.select);
      var exists = $select.find("option").filter(function () {
        return this.value === value;
      }).length > 0;
      if (!exists) $select.append(new Option(value, value, false, false));
    },
    destroy: function () {
      var $select = $(this.$refs.select);
      if ($select.data("select2")) $select.off("change").select2("destroy");
    },
  },
  beforeDestroy: function () {
    this.destroy();
  },
};
</script>



// WEBPACK FOOTER //
// App/Components/BudgetPlan/GLTypeSelect.vue